import React, { Component, useMemo, useState } from "react"
import { graphql, useStaticQuery, Link } from "gatsby"
import Fuse from 'fuse.js'
import debounce from "@tools/debounce"
import "./search.scss"

var fuseOptions = {
  shouldSort: true,
  threshold: 0.4,
  location: 0,
  distance: 100,
  maxPatternLength: 32,
  minMatchCharLength: 1,
  keys: [
    "node.frontmatter.title",
    "node.frontmatter.excerpt"
  ]
};

const allDataQuery = graphql`
query
{
  allMdx(sort: {order: DESC, fields: frontmatter___path}) {
    edges {
      node {
        id
        excerpt(pruneLength: 100)
        frontmatter {
          title
          path
          excerpt
        }
      }
    }
  }
}
`

function Search() {

const clearIcon = require('@images/search/clearIcon.svg'); 
const searchIcon = require('@images/search/searchIcon.svg'); 

const {allMdx: { edges : searchData }} = useStaticQuery(allDataQuery);

const [results, setResults] = useState([])
const [visibility, setVisibility] = useState(false)
const [showClear, setShowClear] = useState(false)
const [iconVis, setIconVis] = useState(false)
const [input, setInput] =  useState("")
const [ noResults, setNoResults] = useState(false)
const fuse = useMemo(() => new Fuse(searchData, fuseOptions), []);

const handleSearch = e => {
    setInput(e.target.value)
    if (input.length >= 0)
    {
      setShowClear(true)
    }

    const found = fuse.search(input);
      if (found.length === 0 || found.length === "[]")
      {
        setNoResults(true)
      }
      else {
        setNoResults(false)
      }
    setResults(found)
}

const handleKeyDown = e =>
{
  if (input.length >= 1)
  {
    setVisibility(true)
  }
}

const handleClear = () => { 
  setInput(" ")
  setShowClear(false)
}

const handleFocus = () =>
{
  setNoResults(false)
  setIconVis(true)
  if (input.length >= 0)
  {
    setShowClear(true)
  }
}

// If any of our wonderful contributors can suggest an alternative I'd be very greatful :)
const handleBlur = () =>
{
  setIconVis(false)
  setTimeout(() => {
    setVisibility(false)
    setShowClear(false)
  }, 100);
}

return (
<div className="searchContainer">
  <div className="fieldContainer">
  <form onReset={handleClear}>
    <div className={"icon " + `${iconVis ? "show" : ""}`}><img src={searchIcon} alt="Search Icon"/></div>
    <input 
      className="search"
      id="search"
      type="text"
      autoComplete="off" 
      placeholder="Search"
      onChange={handleSearch}
      onFocus={handleFocus}
      onBlur={handleBlur}
      onKeyPress={handleKeyDown}
    />
    <button type="reset" className={`${showClear ? "show" : ""}`}><img src={clearIcon}/> </button>
  </form>
</div>
  <div className={`${visibility ? "searchResults show" : "searchResults"}`}>
    <ul>
{  results.map(it => (
    <Link to={it.item.node.frontmatter.path}>
      <li className= {"sr-" + it.item.node.frontmatter.title.replace(/\s+/g, '')}
          key={it.item.node.id}>
          <div>{it.item.node.frontmatter.title}</div>
          <div className="subRes">{it.item.node.frontmatter.excerpt}</div>
      </li>
      </Link>
    ))}
    </ul>
  <div className={"noRes " + `${noResults ? "show" : ""}`}>
    <img src={searchIcon} alt="No Search Results"/>
    <p>No results for "{input}"</p>
    <p className="sub">Try changing your search term by using a different word or phrase.</p>
    <p className="resFeedback">Can't find what you're looking for? <a target="_blank" href="https://pandora20.atlassian.net/jira/software/projects/DS/boards/151">Send feedback</a></p>
  </div>
  <div className="btIndic">Search is currently in beta.</div>
  </div>

</div>
)
}

export default Search;
